import {inject} from '@angular/core'
import {Router} from '@angular/router'
import {Observable} from 'rxjs'
import {AuthService, EAuthState, IAuthInfo} from '../services/auth.service'
import {first, map} from 'rxjs/operators'
import {ROUTE_LOGIN} from './constants'

export const superAuthGuard = (): Observable<boolean | Promise<boolean>> => {
  const authService = inject(AuthService)
  const router = inject(Router)

  return authService.authState$.pipe(
    first(),
    map((authInfo: IAuthInfo) => {
      if (authInfo.state === EAuthState.authenticated && authInfo.user) {
        return authService.isSuperAdmin()
      }
      return router.navigate([ROUTE_LOGIN])
    }))
}

export const authGuard = (): Observable<boolean | Promise<boolean>> => {
  const authService = inject(AuthService)
  const router = inject(Router)

  return authService.authState$.pipe(
    first(),
    map((authInfo: IAuthInfo) => {
      if (authInfo.state === EAuthState.authenticated && authInfo.user) {
        return true
      }
      return router.navigate([ROUTE_LOGIN])
    }))
}
